import { ufoEventConfirmationPageUpdateUserProfile } from "@/components/signup/utils";
import { IBxpWebStargateClient } from "@/libraries/bxp-web-stargate-client/src";

type UpdateUserProfileParams = {
    readonly selectedTeamType: string;
    readonly stargateClient: IBxpWebStargateClient;
    readonly source?: string;
};

/**
 * Updates a user's identity profile.
 * @param selectedTeamType type of team a user is on
 * @param stargateClient stargate client being used by the app
 * @returns null will send analytics if errors or success
 */
export const updateUserProfile = async ({
    selectedTeamType,
    stargateClient,
    source
}: UpdateUserProfileParams) => {
    ufoEventConfirmationPageUpdateUserProfile.start();
    ufoEventConfirmationPageUpdateUserProfile.setCustomData({
        teamType: selectedTeamType,
        ...(source ? { source } : {})
    });
    const { accountId: aaid } = await stargateClient
        .me({})
        .then((res) => {
            console.log(`Send analytics event: 'success me'`);
            return res;
        })
        .catch((e) => {
            ufoEventConfirmationPageUpdateUserProfile.failure({
                error: e
            });
            console.error(`Send analytics event: 'error me'`);
            console.error(e.response);
            return { accountId: "" };
        });

    if (aaid === undefined || aaid === "") {
        ufoEventConfirmationPageUpdateUserProfile.failure({
            error: new Error("AAID not found")
        });
        console.warn("Could not resolve aaid");
        return;
    }

    const extendedProfile = { team_type: selectedTeamType };

    await stargateClient
        .updateIdentityProfile({ aaid, extendedProfile })
        .then(() => {
            ufoEventConfirmationPageUpdateUserProfile.success();
            console.log(
                `Send analytics event: 'success updateIdentityProfile'`
            );
        })
        .catch((e) => {
            ufoEventConfirmationPageUpdateUserProfile.failure({
                error: e
            });
            console.error(
                `Send analytics event error 'error updateIdentityProfile'`
            );
            console.error(e.response);
        });

    return;
};
